import * as z from 'zod';

export const genderQuerySchema = z.enum(['male', 'female', 'other']);

type TGenderQuerySchema = z.infer<typeof genderQuerySchema>;
export type GenderMutationSchema = TGenderQuerySchema;

export const genderFormSchema = z.object({
  name: z.string(),
  value: genderQuerySchema,
});

type GenderFormSchema = z.infer<typeof genderFormSchema>;

export const defaultGender = null;

export const genderOptions: GenderFormSchema[] = [
  { name: 'Male', value: 'male' },
  { name: 'Female', value: 'female' },
  { name: 'Other', value: 'other' },
];

export function strToGender(gender: TGenderQuerySchema | null): GenderFormSchema | null {
  return genderOptions.find((option) => option?.value === gender) ?? null;
}

export function genderToStr(gender: GenderFormSchema | null) {
  return gender?.value ?? null;
}
